import React, { useState } from "react";
import Nav from "../components/sections/Nav";
import Hero from "../components/sections/Hero";
import CrisisStats from "../components/sections/CrisisStats";
import TechCore from "../components/sections/TechCore";
import UseCases from "../components/sections/UseCases";
import BeforeAfter from "../components/sections/BeforeAfter";
import SocialProof from "../components/sections/SocialProof";
import Videos from "../components/sections/Videos";
import Partners from "../components/sections/Partners";
import ROICalculator from "../components/sections/ROICalculator";
import Team from "../components/sections/Team";
import QuizCTA from "../components/sections/QuizCTA";
import Footer from "../components/sections/Footer";
import DemoModal from "../components/sections/DemoModal";
import QuizModal from "../components/sections/QuizModal";

export default function Landing() {
  const [demoOpen, setDemoOpen] = useState(false);
  const [quizOpen, setQuizOpen] = useState(false);

  const openDemo = () => setDemoOpen(true);
  const openQuiz = () => setQuizOpen(true);
  const goToROI = () => {
    const el = document.getElementById("roi");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main className="relative min-h-screen bg-ink text-ink-text overflow-x-hidden">
      <Nav onDemo={openDemo} />
      <Hero onDemo={openDemo} onROI={goToROI} />
      <CrisisStats />
      <TechCore />
      <UseCases />
      <BeforeAfter />
      <SocialProof />
      <Videos />
      <Partners />
      <ROICalculator onDemo={openDemo} />
      <Team />
      <QuizCTA onOpen={openQuiz} />
      <Footer />
      <DemoModal open={demoOpen} onOpenChange={setDemoOpen} />
      <QuizModal open={quizOpen} onOpenChange={setQuizOpen} onWantDemo={openDemo} />
    </main>
  );
}
